export default __webpack_public_path__ + "static/media/aa.d268e7f7.jpg";